import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    Modal,
    Upload,
    message,
    Popconfirm
} from 'antd';

// Components
// import AdvancesTable from './AdvancesTable';
import AdvancesTable from '../../../Credit/Advances/AdvancesTable'
import AdvanceDetail from '../../../Credit/Term Loans/AdvanceDetail'
import { FlexColumn, Flex } from '../../../Reusable/Container';
import { LabeledInput } from '../../../Reusable/Input';
import ModalClose from '../../../../Images/modal-close.png'
import { ErrorAlert } from '../../../Reusable/Alert'
import { Text } from '../../../Reusable/Text';
import { Button, TextButton } from '../../../Reusable/Button';
import { PlusOutlined, FilePdfOutlined, CloseOutlined } from '@ant-design/icons';
// Util
import environment from '../../../../environment'
import { apiGET, getPreSignedS3Url, apiPOSTReq, getJwt } from '../../../../Utils/api';
import { saveAs } from 'file-saver'
// Actions
import { CREDIT_SAVE_DATA, addDataToStore } from '../../../../Actions/actions';
import { cloneDeep } from 'lodash';

class AdvancesIndex extends Component {

    constructor(props) {
        super(props);
        this.state = {
            advancesLoaded: false,
            loading: false
        };
    }

    componentDidMount() {
        getJwt((err, jwt) => {
            this.setState({ jwt });
        });
        var { productType } = this.props;
        if (productType == "RLOC") {
            this.fetchAdvances();
            this.fetchARData();
        }
        else {
            this.fetchAdvancesGNPL();
        }
    }

    fetchAdvances() {
        const headers = {
            businesskey: this.props.businessId
        }

        apiGET("/financing/advances/view", headers, (err, resp) => {
            try {
                const data = resp.data
                console.log("/financing/advances/view", JSON.stringify(data))
                this.props.dispatch(addDataToStore(CREDIT_SAVE_DATA, data))
                this.setState({ advancesLoaded: true })
            } catch (error) {
                console.log("ERRR", error.stack)
            }
        })
    }

    fetchAdvancesGNPL() {
        const headers = {
            businesskey: this.props.businessId
        }

        apiGET("/gnpl/funding/draws", headers, (err, resp) => {

            try {
                this.setState({ advancesLoaded: true })
                const data = resp.data
                console.log("gnpl/funding/draws", data)
                var ifFeesAreToBeDrawn = data.AdvanceInfo.ifFeesAreToBeDrawn;
                this.setState({ ...data, ifFeesAreToBeDrawn: ifFeesAreToBeDrawn })
                if (data.Advances.length == 0) {
                    this.setState({ isZeroAdvances: true })
                }

                // this.fetchBusinessAttributes(this.props.aionStore.BusinessUniqueKey)
            } catch (error) {
                console.log("ERRR", error.stack)
                // ErrorAlert({ description: "Sorry we had trouble processing your request, please try again." })
            }
        })
    }

    // Fetch data for AR
    fetchARData = () => {
        const headers = {
            businesskey: this.props.businessId
        }
        apiGET("/financing/funds/view", headers, (err, resp) => {
            try {
                if (err) throw Error(err);
                const data = resp.data;
                console.log("/financing/funds/view", JSON.stringify(data))
                if (data.success) {
                    this.setState({ advancesLoaded: true, AvailableFunds: data });
                } else {
                    throw Error("We had some trouble. Please try again later.")
                }
            } catch (error) {
                alert(error.message);
            }
        })
    }

    showRejectLoan = (loan) => {
        this.setState({
            showRejectLoan: true,
            loan: loan
        })
    }
    closeRejection = () => {
        this.setState({
            showRejectLoan: false,
            showHoldLoan: false,
        });
    }


    showHoldLoan = (loan) => {
        this.setState({
            showHoldLoan: true,
            loan: loan
        })
    }

    showAdvance = (advance) => {
        console.log("showAdvance", advance)
        this.setState({ selectedAdvance: advance, showAdvanceModal: true })
    }

    fetchAndDownload = (item) => {
        var header = {
            AionCurrentBiz: this.props.businessId
        }

        var body = {
            "BusinessId": this.props.businessId,
            "noteId": item.NoteId
        }

        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/contract/downloadAdvancesContract`, header, body, (err, resp) => {
            try {
                const response = resp || {}
                if (response.result) {
                    const contractDocumentUrl = response.contractDocumentUrl
                    this.setState({ contractDocumentUrl: contractDocumentUrl }, () => this.downloadContract())

                }
                else {
                    ErrorAlert({ description: "Your loan agreement is currently unavailable. Please check back in a few minutes. If you are still unable to view the agreement, please reach out to your customer service contact to obtain this document." })
                }
            }
            catch (error) {
                console.log("ERRR downloading document", error, err, resp);
            }
        })

    }

    downloadContract() {
        return new Promise((resolve, reject) => {
            getPreSignedS3Url({ url: this.state.contractDocumentUrl }, (err, preSignedUrl) => {
                if (!err) {
                    saveAs(preSignedUrl, "AionContract");
                } else {
                    reject(JSON.stringify(err))
                }
            })
        })
    }

    openUpload = (item) => {
        this.setState({ advance: cloneDeep(item), showUpload: true, note: '' })
    }

    handleReason = (event) => {
        var { advance } = this.state;
        const target = event.target;
        if (!advance.AdditionalDetail) {
            advance.AdditionalDetail = {};
        }

        advance.AdditionalDetail.Note = target.value;
        this.setState({ advance: advance });
    }

    handleDeleteDoc = (uploadItem) => {
        var advance = this.state.advance
        var docs = advance.AdditionalDetail.Documents || [];
        var files = [];
        for (var i = 0; i < docs.length; i++) {
            if (docs[i].URI != uploadItem.URI) {
                files.push(docs[i]);
            }
        }

        advance.AdditionalDetail.Documents = files;
        this.setState({ advance: advance });
        // this.handleSubmit();
    }

    handleSubmit = () => {
        const { UserInfo } = this.props.aionStore;

        const body = {
            loggedInUserEmail: UserInfo.Email,
            advance: this.state.advance
        }

        if (this.state.advance.AdditionalDetail == null || this.state.advance.AdditionalDetail.Note == null || this.state.advance.AdditionalDetail.Note == '') {
            ErrorAlert({ description: 'Please enter a valid message!!!' });
            return;
        }

        if (this.state.advance.AdditionalDetail == null || this.state.advance.AdditionalDetail.Documents == null || this.state.advance.AdditionalDetail.Documents.length == 0) {
            ErrorAlert({ description: 'Please upload atleast one document!!!' });
            return;
        }

        this.setState({ loading: true });
        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/saveAdvance`, null, body, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp;
                if (data.result) {
                    this.setState({ showUpload: false });
                    var { productType } = this.props;
                    if (productType == "RLOC") {
                        this.fetchAdvances();
                        this.fetchARData();
                    }
                    else {
                        this.fetchAdvancesGNPL();
                    }
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR newLoanApplicationMessage", error, err, resp);
                ErrorAlert({ description: error.message })
            }
        })
    }

    render() {
        var { productType } = this.props;
        const Advances = this.state.Advances || [];

        var uploadProps = {
            action: `${environment.apiBaseUrl}/file/upload`,
            headers: {
                businesskey: this.props.aionStore.BusinessUniqueKey,
                jwt: this.state.jwt
            },
            beforeUpload: (doc) => {
                this.setState({ uploading: true })
                var maxFileSize = 10240; // 10MB
                const uploadedFileSizeKiloBytes = doc.size / 1024
                if (uploadedFileSizeKiloBytes > maxFileSize) {
                    message.error(`File size is greater than 10MB`);
                    this.setState({ uploading: false });
                    return false;
                }
            },
            showUploadList: false,
            multiple: true,
            onChange: (info) => {
                var { advance } = this.state;
                var savedFileList = advance.AdditionalDetail && advance.AdditionalDetail.Documents ? advance.AdditionalDetail.Documents : [];
                var file = info.file;
                console.log("info file", file);
                var { status, response, name, url } = file;
                if (status === "done") {
                    response = response || {};
                    console.log(response);
                    savedFileList.push({
                        FileName: name,
                        URI: (response.UploadedUrls || response.uploadedUrls || [])[0],
                        file: this.props.includebase64 ? file : null
                    });
                    this.setState({ uploading: false })
                }

                if (!advance.AdditionalDetail) {
                    advance.AdditionalDetail = {};
                }

                advance.AdditionalDetail.Documents = savedFileList.map(item => ({ ...item, url: item.URI }));
                this.setState({ advance: advance });
            }
        };

        var { advance, loading } = this.state;

        return (
            <FlexColumn>
                {
                    productType == "RLOC" && <FlexColumn>
                        {/* <AdvancesTable advancesLoaded={this.state.advancesLoaded} showHoldLoan={this.showHoldLoan} showRejectLoan={this.showRejectLoan} data={this.props.store.ARAdvances} /> */}
                        <AdvancesTable
                            ifFeesAreToBeDrawn={this.state.ifFeesAreToBeDrawn}
                            advancesLoaded={this.state.advancesLoaded}
                            data={this.props.store.ARAdvances}
                            expand={true}
                            fromConsole={true}
                            openUpload={this.openUpload}
                        />
                    </FlexColumn>
                }
                {
                    productType != "RLOC" && <FlexColumn>
                        <AdvancesTable
                            type="short-term"
                            ifFeesAreToBeDrawn={this.state.ifFeesAreToBeDrawn}
                            advancesLoaded={this.state.advancesLoaded}
                            data={this.state.Advances}
                            allowRowClick={true}
                            selectRow={(record) => this.showAdvance(record)}
                            downloadContract={(record) => this.fetchAndDownload(record)}
                            expand={true}
                            fromConsole={true}
                            openUpload={this.openUpload}
                        />
                    </FlexColumn>
                }
                <Modal
                    visible={this.state.showAdvanceModal}
                    footer={null}
                    closable={true}
                    width={800}
                    style={{ top: 20 }}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showAdvanceModal: false })}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <AdvanceDetail advance={this.state.selectedAdvance} businessId={this.props.businessId} downloadContract={(record) => this.fetchAndDownload(record)} />
                </Modal>
                <Modal
                    visible={this.state.showUpload}
                    footer={null}
                    onCancel={() => { this.setState({ showUpload: false }) }}
                    width={600}
                    style={{ top: 20 }}
                    destroyOnClose={true}
                >
                    <FlexColumn>
                        {
                            <Text heading>Add Additional Details</Text>
                        }
                        <Flex start>
                            <LabeledInput
                                label="Note"
                                type="text-area"
                                id="note"
                                key="note"
                                placeholder={`Add a note`}
                                onChange={this.handleReason}
                                value={advance && advance.AdditionalDetail && advance.AdditionalDetail.Note}
                            />
                        </Flex>
                        <Flex start>
                            <Upload
                                {...uploadProps}
                            >
                                <TextButton loading={this.state.uploading} text={"Add Attachments"} color="#40a9ff" icon={<PlusOutlined style={{ fontSize: 14, width: 24, height: 24, color: "#40a9ff" }} />} />
                            </Upload>

                        </Flex>
                        {
                            advance && <Flex start>
                                <Flex start style={{ flexWrap: "wrap", padding: "4px", marginTop: advance && advance.AdditionalDetail && advance.AdditionalDetail.Documents && advance.AdditionalDetail.Documents.length > 0 ? 8 : 0, gap: 16 }}>
                                    {
                                        advance.AdditionalDetail && advance.AdditionalDetail.Documents
                                        && advance.AdditionalDetail.Documents.map((file, i) => {
                                            return (
                                                <>
                                                    <TextButton
                                                        noBorder height='32px' padding='4px 8px' radius='4px' background='#F8F8F8' key={i} color="#40a9ff"
                                                        icon={<FilePdfOutlined style={{ fontSize: 14, color: "#40a9ff" }} />} rightIcon={
                                                            <Popconfirm
                                                                title={<>
                                                                    <div>Are you sure you want to delete this file?</div>
                                                                </>}
                                                                onConfirm={(e) => {
                                                                    e.stopPropagation()
                                                                    this.handleDeleteDoc(file)
                                                                }}
                                                                okText="Confirm"
                                                                placement="left"
                                                                cancelText="Cancel"
                                                                onCancel={(e) => e.stopPropagation()}
                                                            >
                                                                <CloseOutlined style={{ color: "#40a9ff", fontSize: 14 }} />
                                                            </Popconfirm>
                                                        } text={file.FileName} />
                                                </>
                                            );
                                        })
                                    }
                                </Flex>
                            </Flex>
                        }
                        <Flex start>
                            <Button style={{ margin: '20px 0' }} solid loading={loading} onClick={this.handleSubmit} text="Save" />
                        </Flex>
                    </FlexColumn>
                </Modal>
            </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.creditAppReducer,
        aionStore: state.aionAppReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdvancesIndex));